/**
 * Writers View Component - Extracted from CRMTab
 * Handles writer listing and CRUD operations
 */
import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Card, CardContent } from '../ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { Plus, Pencil, Trash2 } from 'lucide-react';

export const WritersView = ({
  writers,
  openWriterDialog,
  handleDeleteWriter,
  t,
}) => {
  return (
    <>
      <div className="flex justify-between items-center">
        <p className="text-slate-500 font-medium">{writers.length} {t.writers}</p>
        <Button onClick={() => openWriterDialog()} className="bg-amber-600 hover:bg-amber-700 text-white shadow-md">
          <Plus className="h-4 w-4 mr-2" />
          {t.newWriter}
        </Button>
      </div>

      <Card className="shadow-md border-slate-200">
        <CardContent className="p-0 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-slate-50">
                <TableHead>{t.name}</TableHead>
                <TableHead>{t.email}</TableHead>
                <TableHead>{t.active}</TableHead>
                <TableHead className="text-right">{t.actions}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {writers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} className="text-center py-8 text-muted-foreground">
                    {t.noWriters}
                  </TableCell>
                </TableRow>
              ) : (
                writers.map((writer) => (
                  <TableRow key={writer.id} className="hover:bg-slate-50/50">
                    <TableCell className="font-medium">{writer.name}</TableCell>
                    <TableCell>{writer.email}</TableCell>
                    <TableCell>
                      <Badge className={writer.active ? 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200' : 'bg-slate-100 text-slate-500'}>
                        {writer.active ? 'Activo' : 'Inactivo'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex items-center justify-end gap-1">
                        <Button 
                          variant="ghost" 
                          size="sm" 
                          onClick={() => openWriterDialog(writer)} 
                          className="text-slate-600 hover:text-amber-600 hover:bg-amber-50"
                        >
                          <Pencil className="h-4 w-4" />
                        </Button>
                        <Button 
                          variant="ghost" 
                          size="sm" 
                          onClick={() => handleDeleteWriter(writer.id)} 
                          className="text-slate-400 hover:text-rose-600 hover:bg-rose-50"
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  );
};

export default WritersView;
